module.exports = __webpack_public_path__ + "media/Video 128b.5ef112b5.mp4";